import { render, staticRenderFns } from "./inline-price.vue?vue&type=template&id=95b5a81e&scoped=true"
import script from "./inline-price.vue?vue&type=script&lang=js"
export * from "./inline-price.vue?vue&type=script&lang=js"
import style0 from "./inline-price.vue?vue&type=style&index=0&id=95b5a81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b5a81e",
  null
  
)

export default component.exports